const isArray = Array.isArray;

export { isArray };
